import React, { createContext, useContext, useState } from 'react';

const ShoppingListContext = createContext();

export function ShoppingListProvider({ children }) {
    const [shoppingList, setShoppingList] = useState([]);

    const addToList = (deal) => {
        setShoppingList(prevList => {
            // Check if deal already exists
            const existingItemIndex = prevList.findIndex(item => item.id === deal.id);
            if (existingItemIndex !== -1) {
                // If item exists, increase quantity
                const updatedList = [...prevList];
                updatedList[existingItemIndex] = {
                    ...updatedList[existingItemIndex],
                    quantity: (updatedList[existingItemIndex].quantity || 1) + 1
                };
                return updatedList;
            } else {
                // If item doesn't exist, add with quantity 1
                return [...prevList, {
                    ...deal, // Preserve all fields from the deal object
                    quantity: 1,
                    dateAdded: new Date().toISOString()
                }];
            }
        });
    };

    const increaseQuantity = (dealId) => {
        setShoppingList(prevList => {
            return prevList.map(item => {
                if (item.id === dealId) {
                    return { ...item, quantity: (item.quantity || 1) + 1 };
                }
                return item;
            });
        });
    };

    const decreaseQuantity = (dealId) => {
        setShoppingList(prevList => {
            return prevList.map(item => {
                if (item.id === dealId) {
                    const newQuantity = (item.quantity || 1) - 1;
                    // If quantity would become 0, keep it at 1 (use removeFromList to actually remove)
                    return { ...item, quantity: Math.max(1, newQuantity) };
                }
                return item;
            });
        });
    };

    const updateQuantity = (dealId, change) => {
        if (change > 0) {
            increaseQuantity(dealId);
        } else if (change < 0) {
            decreaseQuantity(dealId);
        }
    };

    const removeFromList = (dealId) => {
        setShoppingList(prevList => prevList.filter(item => item.id !== dealId));
    };

    const clearList = () => {
        setShoppingList([]);
    };

    return (
        <ShoppingListContext.Provider value={{
            shoppingList,
            addToList,
            removeFromList,
            increaseQuantity,
            decreaseQuantity,
            updateQuantity,
            clearList
        }}>
            {children}
        </ShoppingListContext.Provider>
    );
}

export function useShoppingList() {
    const context = useContext(ShoppingListContext);
    if (!context) {
        throw new Error('useShoppingList must be used within a ShoppingListProvider');
    }
    return context;
} 